
//Libraries
import { defineComponent } from "vue";

//Services
import { runDropdown } from "../../shared/services/dom-service";

//Components
import GameSocial from "./GameSocial.vue";

export default defineComponent({
  name: "GameBasicOptions",
  components: {
    GameSocial,
  },
  setup() {
    //Methods
    const executeDropDown = (isActive: boolean, dropdownId: string) => {
      runDropdown(isActive, dropdownId);
    };

    return {
      //methods
      executeDropDown,
    };
  },
});
